__turbopack_context__.v({
  "cont": "SubscribeForm-module-scss-module__V3yZMa__cont",
  "dataChunk": "SubscribeForm-module-scss-module__V3yZMa__dataChunk",
  "error": "SubscribeForm-module-scss-module__V3yZMa__error",
  "form": "SubscribeForm-module-scss-module__V3yZMa__form",
  "img": "SubscribeForm-module-scss-module__V3yZMa__img",
  "privacy": "SubscribeForm-module-scss-module__V3yZMa__privacy",
});
